import { Pipe, PipeTransform } from '@angular/core';
import * as FORM from '../model/rule-form-grouping.model';
import { FORMTYPE, isFORMSet } from '../model/constants';

@Pipe({ name: 'orderRuleBy' })
export class OrderRuleBy implements PipeTransform {
	/**
	 * Sort by property (root level, only)
	 * @param array
	 * @param field
	 */
	transform(array: any, formType: string): any[] {
		if (!Array.isArray(array)) {
			return [];
		}
		let form;
		// get form rules order
		switch (formType) {
			case FORMTYPE.FORM1004:
				form = FORM.form1004;
				break;
			case FORMTYPE.FORM1073:
			case FORMTYPE.FORM1075:
				form = FORM.form107375;
				break;
			case FORMTYPE.FORM2055:
				form = FORM.form2055;
				break;
			case FORMTYPE.FNMA:
				form = FORM.formFNMA;
				break;
			case FORMTYPE.FREDDIE:
				form = FORM.inspection;
				break;
		}

		if (formType && isFORMSet(formType)){
			form = FORM.inspection;
		}

		let groupingRules = [];

		(form || []).forEach(s => {
			// get rules by section
			const filterd = array.filter(r => {
				const multiUiSections = r.multipleUiSections || [];
				if (
					multiUiSections &&
					multiUiSections.length
				) {
					if (multiUiSections[0].uiSection.toLowerCase() === s) {
						return r;
					}
				}

				// sometimes we not get  multipleUiSections value but uisection
				if (multiUiSections.length < 1 && r.uiSection.toLowerCase() === s) {
					return r;
				}
			});
			// sorting  by individual section
			filterd.sort((a: any, b: any) => {
				if (a.cvSortId < b.vSortId) {
					return -1;
				} else if (a.cvSortId > b.cvSortId) {
					return 1;
				} else {
					return 0;
				}
			});

			if (filterd.length) {
				groupingRules = [...groupingRules, ...filterd];
			}
		});

		return groupingRules;
	}
}
